import { Grid, withStyles } from '@material-ui/core';
import React from 'react';
import { ButtonUI } from '../../common';
import DATA_APPS from './data.json';

const ApplicationInstalledItem_ = ({ app, classes, handleOpenModal }) => {
  const { Name, Logo, Redirect_url } = app;

  return (
    <Grid item xs={12} className={classes.container} component="li">
      <Grid item className={classes.containerImage}>
        <img src={Logo} width="50" height="50" />
        <div className={classes.containerText}>
          <a
            className={classes.link}
            target="_blank"
            href={Redirect_url}
            rel="noreferrer"
          >
            {Name}
          </a>
          <p className={classes.text}>{DATA_APPS[Name].description}</p>
        </div>
      </Grid>
      <Grid item className={classes.containerButton}>
        <ButtonUI
          classes={{ root: classes.button }}
          label="Desinstalar"
          type="callf"
          variant="outlined"
          fullWidth={false}
          onClickFunc={handleOpenModal}
        />
      </Grid>
    </Grid>
  );
};

const styles = (theme) => ({
  container: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  containerImage: {
    display: 'flex',
    alignItems: 'center',
  },
  containerButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '47px 0px 0px',
    [theme.breakpoints.up('sm')]: {
      margin: '0px',
    },
  },
  containerText: {
    marginLeft: '11px',
  },
  link: {
    textDecoration: 'underline !important',
  },
  text: {
    color: '#565656',
    fontSize: '0.87rem',
    fontWeight: 400,
    margin: '3px 0px 0px',
  },
  button: {
    textTransform: 'capitalize',
    fontSize: '0.87rem',
    fontWeight: 600,
    border: '2px solid #53B755',
    minWidth: '142px',
  },
});

export const ApplicationInstalledItem = withStyles(styles)(
  ApplicationInstalledItem_
);
